export const FACEBOOK_APP_ID = '1486888941534126';

export const GOOGLE_CLIENT_ID =
  '551606652723-41jq78qqpst3dgr4jcekpsdee1n4intu.apps.googleusercontent.com';

// this client id belongs to old auth and will get removed in the future
export const WEGO_CLIENT_ID = 'd03c13d00944731e07d1d06cac015242eb3cc52616d77b466fa9de96c19ebc1d';

export const WEGO_AUTH_CLIENT_ID =
  '9a644c3268def69b22ac3f9b82125edb64d0b5075a7f862f3dd83e96606d47fb';
